export default class AccessModalInstanceCtrl {
  constructor($uibModalInstance, data, Requests, $q) {
    const $ctrl = this;
    $ctrl.angular = angular;
    $ctrl.data = data;
    $ctrl.requestTypes = data.types;
    $ctrl.request = data.request;
    $ctrl.accessing = false;

    $ctrl.$onInit = function () {
      if ($ctrl.data.ips == null) {
        $ctrl.data.ips = [$ctrl.data.ip];
      }
    };
    $ctrl.ok = function () {
      $uibModalInstance.close();
    };
    $ctrl.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
    $ctrl.accessTitle = function (type) {
      switch (type) {
        case 'get':
          return 'PROCESS_AS_READ_ONLY';
        case 'get_tar':
          return 'RETRIEVE_AS_CONTAINER';
        case 'get_as_new':
          return 'PROCESS_AS_NEW_GENERATION';
        case 'edit':
          return 'PROCESS_AS_EDITABLE';
        default:
          return 'GET';
      }
    };
    // Access IP
    $ctrl.access = function () {
      $ctrl.accessing = true;
      const data = {
        purpose: $ctrl.data.request.purpose,
        tar: $ctrl.data.request.type === 'get_tar',
        extracted: $ctrl.data.request.type === 'get',
        new: $ctrl.data.request.type === 'get_as_new',
        edit: $ctrl.data.request.type === 'edit',
        package_xml: $ctrl.data.request.package_xml,
        diff_check: $ctrl.data.request.diff_check,
        aic_xml: $ctrl.data.request.aic_xml,
      };
      const promises = [];
      $ctrl.data.ips.forEach(function (ip) {
        promises.push(
          Requests.access(ip, data).then(function (response) {
            return response;
          })
        );
      });
      $q.all(promises)
        .then(function (data) {
          $uibModalInstance.close(data);
          $ctrl.accessing = false;
        })
        .catch(() => {
          $ctrl.accessing = false;
        });
    };
  }
}
